<template>
    <card class="profile-wrapper" v-loading="loading">
        <div class="profile-header" slot="header">
            <h2 class="card-view-header-title">
                <template v-if="model[idKey]">{{title.edit}}</template>
                <template v-else>{{title.add}}</template>
            </h2>
            <el-button v-if="backOpts" :type="backOpts.type" class="profile-header-back-btn" @click.stop="goBack">{{backOpts.text}}</el-button>
        </div>
        <div class="profile-body">
            <jc-form :config="__formConfig"
                ref="form"
                v-if="__formConfig"
                :rules="rules"
                @input="$emit('input', model)"
                :value="model">
                <template v-for="(item, index) in __formConfig.widgets" :slot="`slot-${index}`">
                    <slot :name="`slot-${index}`"/>
                </template>
                <template slot="btns"><slot name="btns"/></template>
            </jc-form>
        </div>
    </card>
</template>

<script>
import Card from '@/components/card'
// import uuidv1 from 'uuid/v1'
import _ from 'lodash'
import JcForm from './form'
export default {
  name: 'jc-basic-profile',
  props: {
    title: { // 标题
      type: Object,
      default () {
        return {
          edit: '编辑',
          add: '新增'
        }
      }
    },
    idKey: { // 详情唯一标识，存在id会被视为编辑
      type: String,
      default: 'id'
    },
    formConfig: { // 表单配置
      type: Object,
      default () {
        return {}
      }
    },
    value: { // 数据源
      type: Object,
      default () {
        return {}
      }
    },
    rules: { // 校验规则
      type: Object,
      default () {
        return {}
      }
    },
    profileApi: { // 详情api
      type: String
    },
    profileParams: { // 详情查询参数
      type: Array,
      default () {
        return []
      }
    },
    queryParams: { // 查询参数
      type: Array,
      default () {
        return []
      }
    }
  },
  watch: {
    formConfig: {
      immediate: true,
      deep: true,
      handler () {
        if (this.formConfig) {
          this.__formConfig = _.merge({}, this.__formConfig, this.formConfig)
        }
      }
    },
    value: {
      immediate: true,
      deep: true,
      handler (val, old) {
        if (this.value && val !== old) {
          this.model = this.value
        }
      }
    },
    profileApi: {
      immediate: false,
      handler (val, old) {
        if (this.profileApi && val !== old) this.getDetail()
      }
    },
    profileParams: {
      immediate: false,
      handler (val, old) {
        if (this.profileParams && Array.isArray(val) && Array.isArray(old)) {
          if (val.toString() !== old.toString()) {
            this.getDetail()
          }
        } else if (this.profileParams && val !== old) this.getDetail()
      }
    },
    back: {
      immediate: true,
      deep: true,
      handler () {
        if (this.back) {
          this.backOpts = _.merge({}, this.backOpts, this.back)
        }
      }
    }
  },
  data () {
    return {
      __formConfig: {
        labelWidth: '150px',
        size: 'small',
        inline: false,
        widgets: []
      },
      model: {},
      submitProcessing: false,
      backOpts: {
        type: '',
        text: '返回',
        query: () => {
          return {}
        }
      },
      loading: false
    }
  },
  components: {
    Card,
    JcForm
  },
  created () {
    if (this.profileApi && this.$route.query[this.idKey]) {
      this.getDetail()
    }
  },
  methods: {
    /**
         * @description 返回按钮
         */
    goBack () {
      if (!this.backOpts.route) {
        this.$router.back()
      } else {
        let route = ''
        if (typeof this.backOpts.route === 'function') {
          route = this.backOpts.route(this.$route, this.model)
        } else {
          route = this.backOpts.route
        }
        let query = this.backOpts.query ? this.backOpts.query(this.$route, this.model) : {}
        this.$router.push({path: route, query})
      }
    },
    /**
         * @description 获取详情接口
         * @author yangyu
         */
    getDetail (params) {
      this.loading = true
      return this.$api('brand/detail', this.createParams())().then(res => {
        if (res) {
          this.model = Object.assign({}, this.model, res)
          this.$nextTick(() => {
            // 清空校验
            this.$refs.form.clearValidate()
            this.loading = false
          })
          this.$emit('input', this.model)
        }
      }).catch(err => {
        this.alert(err)
        this.loading = false
      })
    },
    /**
         * @description 创建获取详情请求参数
         * @author yangyu
         */
    createParams () {
      let params = {}
      if (this.profileParams) {
        this.profileParams.forEach(para => {
          params[para] = this.$route.query[para]
        })
      }
      return params
    },
    /**
         * @description 处理表单配置项值改变
         * @author yangyu
         */
    handleFormItemChange (val, prop) {
      if (prop) {
        this.model[prop] = val
        this.$emit('input', this.model)
      }
    }
  }
}
</script>

<style lang="scss">
.profile-wrapper {
    min-height: 100%;
    .card-view-header {
        padding: 14px 42px!important;
    }
    .profile-header {
        overflow: hidden;
        h2 {
            float: left;
            vertical-align: middle;
            line-height: 36px!important;
        }
        &-back-btn {
            float: right!important;
            vertical-align: middle;
        }
    }
    .profile-body {
        padding: 0px 42px;
        overflow: hidden;
    }
    .profile-footer {
        padding: 0 42px;
        margin-left: 150px;
        margin-bottom: 14px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/profile/basic-profile.vue